<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="25%"
    :show-close="false"
    append-to-body
    custom-class="qrCodeClass payResultDialog"
    destroy-on-close
  >
    <div slot="title" class="text-right">
      <img
        class="pointer"
        src="@/assets/img/close.png"
        alt=""
        width="20"
        height="20"
        @click="handleConfirm"
      />
    </div>
    <div class="text-center">
      <div class="resultTitle">支付结果</div>
      <img
        src="@/assets/img/paySuccess.png"
        alt=""
        width="100"
        height="100"
      />
      <div class="subtitle">
        <span class="ml-1">支付成功</span>
      </div>
    </div>
    <div slot="footer" class="dialog-footer text-center">
      <div class="confirmPayment">
        <span class="pointer" @click="handleConfirm">
          {{ countdown > 0 ? `确认 (${countdown})` : "确认" }}
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import bus from "@/bus.js";
import { isApiSuccess } from "@/utils/subscription";

export default {
  name: "SubscriptionPayResultDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdown: 0,
      timer: null,
      confirmed: false,
      refreshed: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.confirmed = false;
          this.refreshPaySuccessData();
          this.$nextTick(() => {
            this.startCountdown();
          });
          return;
        }
        this.resetCountdown();
        this.refreshed = false;
      },
    },
  },
  beforeDestroy() {
    this.resetCountdown();
  },
  methods: {
    startCountdown() {
      this.resetCountdown();
      this.countdown = 3;
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.handleConfirm();
        }
      }, 1000);
    },
    resetCountdown() {
      this.countdown = 0;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleConfirm() {
      if (this.confirmed) {
        return;
      }
      this.confirmed = true;
      this.resetCountdown();
      this.dialogVisible = false;
      this.$emit("confirm");
    },
    refreshPaySuccessData() {
      if (this.refreshed) {
        return;
      }
      this.refreshed = true;
      const serverUrl = this.$store.state.serverUrl;
      this.$axios
        .get(`${serverUrl}ytb/user/client/team/overview`)
        .then((res) => {
          if (isApiSuccess(res.data.code)) {
            bus.$emit("teamOverviewUpdated", res.data.data || {});
          }
        })
        .catch(() => {});
      this.$axios
        .post(`${serverUrl}ytb/user/client/user/page`, {})
        .then((res) => {
          if (isApiSuccess(res.data.code)) {
            // 新结构 data 为树形数组
            bus.$emit("teamMembersUpdated", res.data.data || []);
          }
        })
        .catch(() => {});
      bus.$emit("allPoints");
    },
  },
};
</script>

<style lang="less">
/* 尺寸按设计稿 px/14 转 rem；字号用 max(12PX, Nrem) 保证小屏不低于 12px */

.qrCodeClass.payResultDialog {
  min-height: auto !important;
  background: #13141a;
  box-shadow: 0 1.78571rem 4.28571rem rgba(0, 0, 0, 0.5);
  border-radius: 0.85714rem;
  color: #e5e7eb;

  .el-dialog__header {
    padding: 1.14286rem 1.42857rem 0;
  }

  .el-dialog__body {
    padding: 0 1.42857rem;
    color: #94a3b8;
  }

  .el-dialog__footer {
    padding: 0 1.42857rem 1.71429rem;
  }

  .resultTitle {
    font-size: ~"max(12PX, 1.57143rem)";
    color: #fff;
    text-align: center;
    line-height: 1.57143rem;
    font-weight: 600;
    margin-bottom: 1.42857rem;
  }

  .subtitle {
    display: flex;
    flex-direction: column;

    > span:nth-child(1) {
      font-size: ~"max(12PX, 1.14286rem)";
      font-weight: 600;
      line-height: 1.14286rem;
      text-align: center;
      color: #fff;
      margin-top: 1.07143rem;
    }
  }

  .confirmPayment {
    height: 2.57143rem;
    background: linear-gradient(135deg, #a855f7, #6366f1);
    border-radius: 2rem;
    font-size: ~"max(12PX, 1.07143rem)";
    color: #ffffff;
    line-height: 2.57143rem;
    padding: 0 1.71429rem;
    display: inline-block;
    margin-top: 1.35714rem;
    cursor: pointer;
    box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
    transition: all 0.25s;

    &:hover {
      box-shadow: 0 0.42857rem 1.42857rem rgba(99, 102, 241, 0.5);
      transform: translateY(-1px);
    }
  }
}
</style>
